import { motion } from "framer-motion";
import { Reveal } from "@/components/Reveal";

const WORKS = [
  {
    src: "https://images.unsplash.com/photo-1766503206606-27de0861e8a4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwzfHxtb2JpbGUlMjBhcHAlMjBkZXNpZ24lMjBpbnRlcmZhY2UlMjB0ZWNoJTIwc3R1ZGlvfGVufDB8fHx8MTc4OTU4MTY3NXww&ixlib=rb-4.1.0&q=85",
    alt: "Mobile app interfaces on modern smartphones",
    label: "Mobile Apps",
    title: "Pocket-sized products",
    testid: "work-card-mobile",
  },
  {
    src: "https://images.pexels.com/photos/54284/pexels-photo-54284.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Clean web application analytics interface",
    label: "Web Applications",
    title: "Dashboards that deliver",
    testid: "work-card-web",
  },
  {
    src: "https://images.unsplash.com/photo-1784407082880-7614c3597fd2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwyfHxtb2JpbGUlMjBhcHAlMjBkZXNpZ24lMjBpbnRlcmZhY2UlMjB0ZWNoJTIwc3R1ZGlvfGVufDB8fHx8MTc4OTU4MTY3NXww&ixlib=rb-4.1.0&q=85",
    alt: "Minimalist smartphone on dark studio pedestal",
    label: "Product Craft",
    title: "Detail-obsessed builds",
    testid: "work-card-craft",
  },
];

export const Showcase = () => (
  <section id="work" data-testid="showcase-section" className="relative py-24 lg:py-32">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <p className="font-mono text-xs sm:text-sm uppercase tracking-[0.25em] text-teal-400">
          03 — The craft
        </p>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-zinc-50 max-w-2xl">
          Built to be touched, tapped, and trusted.
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
        {WORKS.map((w, i) => (
          <motion.figure
            key={w.testid}
            data-testid={w.testid}
            initial={{ clipPath: "inset(0 0 100% 0)", opacity: 0.4 }}
            whileInView={{ clipPath: "inset(0 0 0% 0)", opacity: 1 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 1, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
            className="group relative rounded-2xl overflow-hidden border border-zinc-800 bg-[#1A1B20] aspect-[4/5] hover:border-teal-500/50 transition-colors duration-500"
          >
            <img
              src={w.src}
              alt={w.alt}
              loading="lazy"
              className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#121316] via-[#121316]/25 to-transparent" />
            <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-700 bg-[radial-gradient(circle_at_50%_30%,rgba(45,212,191,0.16),transparent_60%)]" />
            <figcaption className="absolute bottom-0 left-0 right-0 p-6">
              <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-teal-400">
                {w.label}
              </p>
              <p className="mt-1.5 font-display text-lg font-semibold text-zinc-50">{w.title}</p>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);
